import { useSelector } from 'react-redux';

import TileCard from './TileCard.jsx';
import { useShowTileForm } from '../../../../lib/redux/hooks/useShowTileForm';

const NewTile = () => {
  const { createTile } = useShowTileForm();
  const { newTileForm } = useSelector(state => state.userData);

  const handleClick = () => {
    if (newTileForm) {
      createTile();
    } else {
      const tileForm = window.Airbo.TileFormModal;
      const tileManager = window.Airbo.TileManager;
      tileForm.init(tileManager);
      tileForm.open('/client_admin/tiles/new');
    }
  };

  return (
    <TileCard
      handleClick={handleClick}
      id="new-tile-btn"
      text="Create Tile"
      icon="fa-solid fa-plus fa-2x"
    />
  );
};

export default NewTile;
